import CityPageTemplate from "../city-template/CityPageTemplate";
import { bellevueConfig } from "./data";

export default function BellevuePage() {
  return <CityPageTemplate config={bellevueConfig} />;
}